import React from 'react';
import { Color, COLORS } from '../../styles/variables';

interface ChevronDownIconProps {
  size?: number;
  color?: Color;
  rotate?: boolean;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  size = 12,
  color = COLORS.black,
  rotate = false,
}) => (
  <svg
    style={{ transition: 'all 0.4s', transform: !rotate ? 'unset' : 'rotate(180deg)' }}
    width={size}
    viewBox="0 0 12 6"
    fill="none"
  >
    <path d="M 0 0 L 6 4 L 12 0" stroke={color} />
  </svg>
);

export default ChevronDownIcon;
